import { gql } from '@apollo/client';
import { InitUnderwritingAsTenantCommand } from '@contexts/Estate/EstateApplication';
import { option } from 'fp-ts';

export const InitUnderwritingAsTenantSchema = gql`
  mutation InitializeUnderwriting($input: InitUnderwritingAsTenantInputType!) {
    initializeUnderwriting(input: $input) {
      value
    }
  }
`;

export type GqlInitUnderwritingAsTenantRequestType = {
  input: GqlInitUnderwritingAsTenantInputType;
};

export namespace GqlInitUnderwritingAsTenantRequestType {
  export const from = (
    command: InitUnderwritingAsTenantCommand
  ): GqlInitUnderwritingAsTenantRequestType => ({
    input: {
      estate: {
        estateId: command.estateInfo.estateId.value,
        admonPrice: command.estateInfo.admonPrice.value,
        rentalPrice: command.estateInfo.rentalPrice.value,
        broker: option.toUndefined(command.estateInfo.broker)?.value,
      },
      tenantName: command.tenant.name,
      tenantPhone: command.tenant.phone,
    },
  });
}

export type GqlInitUnderwritingAsTenantInputType = {
  estate: {
    estateId: number;
    admonPrice: number;
    rentalPrice: number;
    broker?: number;
  };
  tenantName?: string;
  tenantPhone?: string;
};

export type GqlInitUnderwritingAsTenantResponseType = {
  initializeUnderwriting: {
    value: string;
  };
};
